import { Card, CardContent, Divider, Grid, IconButton, ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';
import { Done, MoreVert } from '@material-ui/icons';
import { accessSync } from 'fs';
import React, { useContext, useEffect, useState } from 'react';

import { EmployeeWidgetControllerService } from '../../../api/client';
import { getReportedEmployeeCounts, hideWidget } from '../../../api/hs/dashboard/widget/widget';
import { DateRange, ReportedEmployeeCounts, WidgetType } from '../../../api/hs/dashboard/widget/widget.payload';
import { getEmployeeCounts } from '../../../api/hs/employee';
import { useAsyncEffect } from '../../../utils';
import { dateRangeOptions } from '../../../utils/use-date-range-state';
import colors from '../colors';
import { DialogContext } from '../dialog.context';
import DateRangeDialog from './DateRangeDialog';
import DropdownMenuContainer from './Menu/DropdownMenuContainer';

export default ({ reload }) => {
  const [counts, setCounts] = useState<ReportedEmployeeCounts>();
  const [dialogVisibility, setDialogVisibility] = useState<boolean>(false);
  const [menuAnchor, setMenuAnchor] = React.useState<null | HTMLElement>(null);

  const {
    employeeWidget: { open },
    employeeWidgetDateRange: { dateRange, days, setRangeByDays, setRange },
  } = useContext(DialogContext);

  useEffect(() => {
    setRangeByDays(7);
  }, [setRangeByDays]);

  useAsyncEffect(async () => {
    if (dateRange) {
      await getEmployeeCounts(new DateRange(dateRange.start, dateRange.end)).then(setCounts);
    }
  }, [dateRange]);

  const hide = () => {
    hideWidget({ widgetType: WidgetType.EMPLOYEE }).then(reload);
  };

  const handleClickMoreButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  return (
    <Card key="employee" className="m-1 dashboard-stats-card" style={{ backgroundColor: colors.employee }}>
      <CardContent>
        <Grid container style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Grid item sm={10} onClick={open}>
            <h3>Personel Bilgileri</h3>
          </Grid>
          <Grid item sm={2}>
            <IconButton onClick={handleClickMoreButton}>
              <MoreVert />
            </IconButton>
            <DropdownMenuContainer anchor={menuAnchor} setAnchor={setMenuAnchor} hide={hide}>
              <>
                {dateRangeOptions.map(dateRangeOption => (
                  <MenuItem key={dateRangeOption} onClick={() => setRangeByDays(dateRangeOption)}>
                    <ListItemIcon>{dateRangeOption === days && <Done fontSize="small" />}</ListItemIcon>
                    <ListItemText>{dateRangeOption} Gün</ListItemText>
                  </MenuItem>
                ))}
                <MenuItem onClick={() => setDialogVisibility(true)}>
                  <ListItemIcon>{days === undefined && <Done fontSize="small" />}</ListItemIcon>
                  <ListItemText>Diğer...</ListItemText>
                </MenuItem>
              </>
            </DropdownMenuContainer>
          </Grid>
        </Grid>
        <Grid style={{ display: 'flex', flexDirection: 'column' }} container onClick={open}>
          <Grid item sm={12}>
            <h3>Çalışan Personel : {counts?.activeEmployee || 0}</h3>
          </Grid>
          <Divider />
          <p>Yeni Personel : {counts?.newEmployee || 0}</p>
        </Grid>
      </CardContent>
      <DateRangeDialog close={() => setDialogVisibility(false)} opened={dialogVisibility} setRange={setRange} dateRange={dateRange} />
    </Card>
  );
};
